import numeral from "numeral";
import Cookies from 'js-cookie'
import _ from 'lodash';
import { v4 } from 'uuid';
const contains = require('lodash.contains');
export const USERID = 'userId'
export const SAVEDLOCATIONS = 'sl'
export const isEmpty = (value) => {
    return _.isEmpty(value);
};


export const getNumeric = (value, isDecimal) => {
    if (isDecimal) {
        return numeral(value).format('0,0[.]0');
    } else {
        return numeral(value).format('0,0');
    }
}

export const getBrowserClientId = () => {
    let browserClientId = Cookies.get('browserClientId');
    if (isEmpty(browserClientId)) {
        browserClientId = v4();
        Cookies.set('browserClientId', browserClientId);
    }
    return browserClientId;
}
export const getUserId = () => {
    return localStorage.getItem(USERID) && Cookies.get(USERID) ? localStorage.getItem(USERID) : Cookies.get(USERID) && !localStorage.getItem(USERID) ? Cookies.get(USERID) : null;
}

export const autoplayIcon=(size=16,fill='#00000')=>{
    return <svg xmlns="http://www.w3.org/2000/svg" width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${size} ${size}`}>
    <path fill={fill} fill-rule="evenodd" d="M5.23331,0.493645 C6.8801,-0.113331 8.6808,-0.161915 10.3579,0.355379 C11.4019,0.6773972 12.361984,1.20757325 13.1838415,1.90671757 L13.4526,2.14597 L14.2929,1.30564 C14.8955087,0.703065739 15.9071843,1.0850774 15.994017,1.89911843 L16,2.01275 L16,6.00002 L12.0127,6.00002 C11.1605348,6.00002 10.7153321,5.01450817 11.2294893,4.37749065 L11.3056,4.29291 L12.0372,3.56137 C11.389,2.97184 10.6156,2.52782 9.76845,2.26653 C8.5106,1.87856 7.16008,1.915 5.92498,2.37023 C4.68989,2.82547 3.63877,3.67423 2.93361,4.78573 C2.22844,5.89723 1.90836,7.20978 2.02268,8.52112 C2.13701,9.83246 2.6794,11.0698 3.56627,12.0425 C4.45315,13.0152 5.63528,13.6693 6.93052,13.9039 C8.22576,14.1385 9.56221,13.9407 10.7339,13.3409 C11.9057,12.7412 12.8476,11.7727 13.4147,10.5848 C13.6526,10.0864 14.2495,9.8752 14.748,10.1131 C15.2464,10.351 15.4575,10.948 15.2196,11.4464 C14.4635,13.0302 13.2076,14.3215 11.6453,15.1213 C10.0829,15.921 8.30101,16.1847 6.57402,15.8719 C4.84704,15.559 3.27086,14.687 2.08836,13.39 C0.905861,12.0931 0.182675,10.4433 0.0302394,8.69483 C-0.122195,6.94637 0.304581,5.1963 1.2448,3.7143 C2.18503,2.2323 3.58652,1.10062 5.23331,0.493645 Z M6,5.46077 C6,5.09472714 6.37499031,4.86235811 6.69509872,5.0000726 L6.7678,5.03853 L10.7714,7.57776 C11.0528545,7.75626909 11.0784413,8.14585256 10.8481603,8.36273881 L10.7714,8.42224 L6.7678,10.9615 C6.45867857,11.1575214 6.06160816,10.965274 6.00646097,10.6211914 L6,10.5392 L6,5.46077 Z"/>
  </svg>
}
export const formatBytes = (a, b = 2) => {
    if (0 === a) return "0 Bytes";
    const c = 0 > b ? 0 : b, d = Math.floor(Math.log(a) / Math.log(1024));
    return parseFloat((a / Math.pow(1024, d)).toFixed(c)) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
};
export const getExtension = (name) => {
    if(name)
    {var ext = name?.split(".");
    return ext[ext.length-1];}
    else return ""
}
export const getFileName = (name) => {
    if(name){
        var name =name?.split("/");
        return name[name.length-1];
    }
    else{}
}
export const getFolderName = (name) => {
    if(name){
        var name =name?.split("/");
        return name[1];
    }
    else{}
}
export const getExactFolderName = (name) => {
    if(name){
        var name =name?.split("/");
        return name[name.length-2];
    }
    else{}
}
export const getParentFolderName = (name,truncatePart) => {
    if(name){
        var name =name?.split(truncatePart);
        name=_.split(name[1],'/')
        return name[0];
    }
    else{}
}
export const getFolderFullName=(fullName,fileName)=>{
    let subStrings=_.split(fullName,"/");
    //_.remove(subStrings,fileName)
    _.remove(subStrings, function(n) {
        return n == fileName;
      });
    return _.compact(subStrings).join("/")

}
export const removeFileName = (name) => {
    if(name){
        var name =name?.split("/");
        name.pop();
        return name.join("/");
    }
    else{}
}
export const getDataUrl = (name,selectedFile) => {
    let type = getExtension(name)
    switch (_.lowerCase(type)) {
        case 'xlsx':
            return "data:application/xlsx;base64," + selectedFile
        case 'pdf':
            return "data:application/pdf;base64," + selectedFile
        case 'jpeg':
            return "data:image/jpeg;base64," + selectedFile
        case 'jpg':
            return "data:image/jpg;base64," + selectedFile
        case 'png':
            return "data:image/png;base64," + selectedFile
        case 'gif':
            return "data:image/gif;base64," + selectedFile
        case 'bmp':
            return "data:image/bmp;base64," + selectedFile
        case 'svg':
            return "data:image/svg+xml;base64," + selectedFile
        case 'tiff':
            return "data:image/tiff;base64," + selectedFile
        case 'zip':
            return "data:application/zip;base64," + selectedFile
        case 'docx':
            return "data:application/docx;base64," + selectedFile
        case 'csv':
            return "data:application/csv;base64," + selectedFile
        default:
            return null;
    }
}
export const getMimeType = (name) => {
    let type = getExtension(name)
    switch (_.lowerCase(type)) {
        case 'xlsx':
            return "application/octet-stream;" 
        case 'pdf':
            return "application/octet-stream" 
        case 'zip':
            return "application/octet-stream" 
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'gif':
        case 'bmp':
            return "image/png";
        case 'svg':
            return "image/svg";
        case 'tiff':
            return "image/tiff";
        case 'webp':
            return "image/webp";
        case 'docx':
        case 'csv':    
            return "application/octet-stream" 

        default:
            return null;
    }
}
export function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return 'n/a';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    if (i == 0) return bytes + ' ' + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
};
export const convertArrayToDictionary = (array, id) => {
    var obj = {};
    _.map(array, (item) => {
        if (id) {
            obj[item[id]] = item;
        } else {
            obj[item] = item;
        }
        return item;
    })
    return obj;
};
export const filterByValues = (collection, key, values) => {
    return _.filter(collection, function (o) {
        return contains(values, resolveKey(o, key));
    });
};
export const excludeByValues = (collection, key, values) => {
    return _.filter(collection, function (o) {
        return !contains(values, resolveKey(o, key));
    });
};
export const resolveKey = (obj, key) => {
    if (obj === null || key === null) {
        return undefined;
    }
    var resolved = undefined;
    if (typeof key === 'function') {
        resolved = key(obj);
    } else if (typeof key === 'string') {
        resolved = obj[key];
        if (resolved === null && key.indexOf(".") !== -1) {
            resolved = _.deepGet(obj, key);
        }
    }
    return resolved;
};
export const getIconName = (ext) => {
    switch (_.lowerCase(ext)) {
        case 'xlsx':
            return "~/../xlsx.svg" 
        case 'pdf':
            return "~/../pdf.svg" 
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'svg':
        case 'tiff':
        case 'webp':
            return "~/../photo.svg" 
        case 'docx':
            return "~/../docx.svg"
        case 'csv':     
            return "~/../csv.svg" 
        case 'folder':
            return "~/../folder.svg" 
        case 'zip':
            return "~/../zip.svg"
        default:
            return "~/../doc.svg"
    }
}
export const getFileTypes = () => {
    return [
        {value:'xlsx',label:'xlsx'},
        {value:'pdf',label:'pdf'},
        {value:'jpeg',label:'jpeg'},
        {value:'jpg',label:'jpg'},
        {value:'png',label:'png'},
        {value:'gif',label:'gif'},
        {value:'bmp',label:'bmp'},
        {value:'docx',label:'docx'},
        {value:'csv',label:'csv'},
        {value:'svg',label:'svg'},
        {value:'zip',label:'zip'},
        {value:'tiff',label:'tiff'},
        {value:'webp',label:'webp'},
    ]
}
export const countFiles = (files,folders,mainFolder) => {
    
    _.map(mainFolder,folder=>{
        files=_.filter(files,it=>!_.includes(it,folder))
    })
    return files?.length+mainFolder?.length
}
